import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import { withSwal } from 'react-sweetalert2';
// components

import './business-dashboard.scss';

import { useTranslation } from 'react-i18next';
import { ApiError } from '../../utils/api/ApiError';
import PageTitle from '../../components/PageTitle';
import 'rsuite/dist/rsuite.css';
import DashboardGraph from './DashboardGraph';
import { getUsers } from '../../utils/api/users';
import { User } from '../../interfaces/User';
import globalErrorHandler from '../../utils/globalErrorHandler';

// main component
const BusinessDashboard = withSwal((props: any) => {
    useEffect(() => {
        document.title = 'Business Dashboard';

        return () => {
            document.title = 'Better Admin';
        };
    }, []);

    const { t } = useTranslation();
    const navigate = useNavigate();
    const mounted = useRef(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [users, setUsers] = useState<User[]>([]);

    const handleData = async () => {
        try {
            setLoading(true);
            const usersResult = await getUsers();
            setUsers(usersResult.users);
            setLoading(false);
        } catch (err: any) {
            setLoading(false);
            globalErrorHandler(err);
            // alert("Error getting data");
        }
    };

    useEffect(() => {
        mounted.current = true;
        if (mounted) {
            handleData();
        }

        return () => {
            mounted.current = false;
        };
    }, []);

    return (
        <React.Fragment>
            <PageTitle
                breadCrumbItems={
                    [
                        // {label: 'Insurance Companies', path: '/apps/crm/customers', active: true},
                    ]
                }
                title={'Business Dashboard'}
            />

            <Row>
                <Col xl={12} lg={12}>
                    <DashboardGraph title={'Business Dashboard'} users={users} dynamicGraph={true} />
                </Col>
            </Row>
        </React.Fragment>
    );
});
export default BusinessDashboard;
